import PropTypes from 'prop-types';
import Icon from './Badge';
import Price from './Price';
import { ProPricesStyles } from './ProPrice.style';

const ProPrice = ({ proPrice, regionCode, getPrice, getUnitPrice, mode }) => {
  if (!Object.entries(proPrice).length) {
    return null;
  }

  return (
    <div className="pro-prices-container">
      <Icon proPrice={proPrice} regionCode={regionCode} />
      <Price proPrice={proPrice} getPrice={getPrice} getUnitPrice={getUnitPrice} mode={mode} />
      <style jsx>{ProPricesStyles}</style>
    </div>
  );
};

ProPrice.defaultProps = {
  getPrice: () => {},
  proPrice: {},
  regionCode: 'cl',
  getUnitPrice: () => {},
  mode: 'PDP_MAIN',
};

ProPrice.propTypes = {
  getPrice: PropTypes.func,
  proPrice: PropTypes.object,
  regionCode: PropTypes.string,
  getUnitPrice: PropTypes.func,
  mode: PropTypes.string,
};

export default ProPrice;
